import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import cx from 'classnames';
import TruncateMarkup from 'react-truncate-markup';
import Skeleton from '../../../../core/components/Skeleton';
import customizableComponent from '../../../../core/hocs/customization';
import Time from '../../../../core/components/Time';
import Avatar from '../../../../core/components/Avatar';
import BanIcon from '../../../../icons/Ban';
import { backgroundImage as UserImage } from '../../../../icons/User';
import { AccessCode, Name, PostInfo, ShieldIcon, ModeratorBadge, AdditionalInfo, PostTarget, PostHeaderContainer, PostNamesContainer, MessageContainer, } from './styles';
const UIPostHeader = ({ userType, avatarFileUrl, postAuthorName, postAuthorId, postTargetName, timeAgo, isModerator, isModeratorTagVisible = false, isEdited, onClickCommunity, onClickUser, hidePostTarget, loading, isBanned, }) => {
    const renderPostNames = () => {
        return (React.createElement(PostNamesContainer, { "data-qa-anchor": "post-header-post-names" },
            React.createElement(TruncateMarkup, { lines: 3 },
                React.createElement(Name, { "data-qa-anchor": "post-header-post-name", className: cx({ clickable: !!onClickUser }), onClick: onClickUser, isHighlighted: !!userType }, postAuthorName)),
            postAuthorId &&
                React.createElement(AccessCode, { "data-qa-anchor": "post-header-post-accesscode" }, `(${postAuthorId})`),
            isBanned && React.createElement(BanIcon, { height: 14, width: 14 })));
    };
    const renderAdditionalInfo = () => {
        return (React.createElement(AdditionalInfo, { showTime: !!timeAgo, "data-qa-anchor": "post-header-additional-info" },
            postTargetName && !hidePostTarget && (React.createElement(PostTarget, { "data-qa-anchor": "post-header-post-target-name", className: cx({ clickable: !!onClickCommunity }), onClick: onClickCommunity }, postTargetName)),
            isModerator && isModeratorTagVisible && (React.createElement(ModeratorBadge, { "data-qa-anchor": "post-header-additional-info-moderator-badge" },
                React.createElement(ShieldIcon, { width: 14, height: 14 }),
                " ",
                React.createElement(FormattedMessage, { id: "moderator" }))),
            timeAgo && React.createElement(Time, { date: timeAgo }),
            isEdited && (React.createElement(MessageContainer, { "data-qa-anchor": "post-header-additional-info-edited-label" },
                React.createElement(FormattedMessage, { id: "post.edited" })))));
    };
    return (React.createElement(PostHeaderContainer, { "data-qa-anchor": "post-header" },
        React.createElement(Avatar, { displayName: typeof postAuthorName === 'string' ? postAuthorName : undefined, "data-qa-anchor": "post-header-avatar", avatar: avatarFileUrl, backgroundImage: UserImage, loading: loading, onClick: onClickUser }),
        React.createElement(PostInfo, { "data-qa-anchor": "post-header-post-info" }, loading ? (React.createElement(React.Fragment, null,
            React.createElement("div", null,
                React.createElement(Skeleton, { width: 96, style: { fontSize: 8 } })),
            React.createElement(Skeleton, { width: 189, style: { fontSize: 8 } }))) : (React.createElement(React.Fragment, null,
            renderPostNames(),
            renderAdditionalInfo())))));
};
UIPostHeader.propTypes = {
    userType: PropTypes.string,
    avatarFileUrl: PropTypes.string,
    postAuthorName: PropTypes.node,
    postAuthorId: PropTypes.string,
    postTargetName: PropTypes.string,
    timeAgo: PropTypes.instanceOf(Date),
    isModerator: PropTypes.bool,
    isModeratorTagVisible: PropTypes.bool,
    isEdited: PropTypes.bool,
    hidePostTarget: PropTypes.bool,
    loading: PropTypes.bool,
    isBanned: PropTypes.bool,
    onClickCommunity: PropTypes.func,
    onClickUser: PropTypes.func,
};
UIPostHeader.defaultProps = {
    avatarFileUrl: '',
    postAuthorName: '',
    postAuthorId: null,
    postTargetName: '',
    timeAgo: null,
    isModerator: false,
    isEdited: false,
    hidePostTarget: false,
    loading: false,
    isBanned: false,
    onClickCommunity: null,
    onClickUser: null,
};
export default customizableComponent('UIPostHeader', UIPostHeader);
//# sourceMappingURL=UIPostHeader.js.map